import React from "react";
import pdf from './resources/pdf.pdf';

import BasePdf from "../Base/pdf";

const SecurityModulePdf = () => {
    return <BasePdf
        pdf={pdf}
    >
        JAK A CO CHRÁNIT<br/>
        <br/>
        JAK TO TEDY JE<br/>
        <br/>
        Ochraně duševního vlastnictví je v současné době v Česku věnována poměrně velká pozornost – a to jak v
        podnikatelském světě, tak na akademické půdě. Obecně se má za to, že české subjekty málo chrání svá řešení a
        podávají málo patentů – alespoň například v porovnání s obdobím první Československé republiky či se srovnatelně
        velkými a průmyslově vyspělými zeměmi. Pokud máte o mezinárodní srovnání zájem, tak se můžete podívat na
        patentové statistiky, které zpracovává ve spolupráci s Úřadem průmyslového vlastnictví Český statistický
        úřad.<br/>
        <br/>
        Tématika duševního vlastnictví a jeho ochrany se objevuje v poslední době i ve strategických dokumentech.
        Součástí inovační strategie CZECH REPUBLIC: THE COUNRY FOR THE FUTURE, kterou vypracovala Rada pro výzkum, vývoj
        a inovace (RVVI) v roce 2019, je dokonce samostatný pilíř THE COUNTRY FOR PATENTS: OCHRANA DUŠEVNÍHO
        VLASTNICTVÍ. Dle textu tohoto dokumentu by se mělo zvýšit povědomí o ochraně duševního vlastnictví – jak v rámci
        vzdělávací soustavy, tak ve výrobní a aplikační sféře. A ochrana by se měla více využívat, a to především u
        patentů s komerčním potenciálem.<br/>
        <br/>
        Je dobré si připomenout jeden důležitý moment, díky kterému došlo k určité změně postoje k průmyslově-právní
        ochraně v akademické sféře. Ke změně v chování přihlašovatelů vynálezů a užitných vzorů došlo po roce 2010. V
        tomto období byl přijat nový způsob hodnocení a následné financování výstupů výzkumných organizací, tzv.
        „kafemlejnek“. Za výsledky začaly být přidělovány body a na základě dosaženého počtu bodů byly rozdělovány
        finanční prostředky. V rámci tohoto systému byly výzkumné organizace finančně motivovány k tomu, aby podávaly
        více<br/>
        patentů, a to nejlépe těch mezinárodních – tj. například evropských, amerických či japonských.<br/>
        <br/>
        Podle tehdejší Metodiky hodnocení bylo za „evropský patent“ a patent USA a Japonska 500 bodů – tj. stejně jako
        za článek v prestižním impaktovaném časopise typu Nature či Science. Za národní patent bylo 200 bodů, za užitný
        a průmyslový vzor 40 bodů.<br/>
        Jakmile se následně metodika změnila a za podané patenty a užitné vzory body už nebyly, počet přihlašovaných
        řešení se ze strany výzkumných organizací zcela logicky snížil. To vidíme i v patentové statistice.<br/>
        <br/>
        Také je vhodné si uvědomit, že mnoho projektů aplikovaného výzkumu (především programy Technologické agentury či
        Ministerstva průmyslu a obchodu) musí mít již při svém podávání stanoveny výstupy – velmi často se jedná o
        patenty a užitné vzory.<br/>
        Ochrana duševního vlastnictví je ale především nástroj konkurenceschopnosti podnikatelských subjektů, které něco
        vyrábějí či nabízejí své výrobky a služby na trhu. Těmto subjektům nástroje ochrany duševního vlastnictví slouží
        k tomu, aby mohly po určitou dobu na určitém území užívat „monopol“ na své řešení či výrobek. Kdyby
        formalizovaná ochrana duševního vlastnictví neexistovala, tak by se v podstatě nevyplatilo nic vynalézat a
        stačilo by čekat a beztrestně kopírovat řešení a výrobky, které jsou již na trhu.<br/>
        <br/>
        O způsobu ochrany rozhodují v podstatě dvě skutečnosti. Za prvé to, o jaký druh nápadu se jedná – nový výrobek,
        nová látka, řešení, postup, metoda, vzhled, slogan nebo například software. Dle toho se pak volí nejvhodnější
        způsob ochrany. Za druhé je důležité, jaké další záměry původce vynálezu má. Zda chce svoji myšlenku sám
        komerčně využívat, zda chce založit vlastní společnost (start-up) anebo chce nápad prodat či licencovat nějaké
        jiné společnosti. Je totiž zásadní, co a jak chci se svým řešení dělat, jaké mám ambice a také třeba kolik mám
        finančních prostředků, které mohu na ochranu svého řešení věnovat.<br/>
        <br/>
        Ve své podstatě existují dva základní způsoby, jak nějaký nápad ochránit. První možností je nápad utajovat.
        Tento postup se běžně uplatňuje například u receptů nebo u složení látek, které je velmi těžko
        identifikovatelné. Nebo je to vhodné v oborech, kdy nové postupy či výrobky vznikají velmi rychle, v řádu
        měsíců, a nemá cenu čekat na udělení průmyslově-právní ochrany. Tento postup nám ale nezaručí to, že stejné
        řešení nenalezne někdo jiný. A náš nápad není formálně vůbec chráněn.<br/>
        <br/>
        Druhou možností je naše řešení, postup či látku chránit pomocí dostupných nástrojů průmyslově-právní ochrany –
        například pomocí patentu, užitného nebo průmyslového vzoru. A jsou v podstatě dva důvody, proč volíme tento typ
        ochrany. První je ten, že chráněné řešení chceme my sami použít k vlastní podnikatelské činností – tj. toto
        chráněné řešení nabízet na trhu a tím mít na vybraných územích zajištěnou ochranu. Druhý důvod je ten, že
        chceme, aby námi objevené řešení nikdo nevyráběl. Tím si například pojistíme používání dosavadních řešení a
        postupů, které chceme ještě nějakou dobu ekonomicky využívat. Proto nové řešení budeme chránit a tím docílíme,
        že ho nesmí vyrábět a používat ani nikdo jiný.<br/>
        <br/>
        Třetí možností, jak se svým řešením naložit, je jeho zveřejnění. Tím dosáhneme toho, že řešení si již nikdo
        nebude moci patentovat, ale současně nezabráníme tomu, aby řešení byla využívána neomezeně kýmkoliv.<br/>
        <br/>
        Zapamatujte si, že ochrana software je v zemích EU poměrně komplikovaná – obecně patří software – tj. způsob,
        jak je počítačový program napsán – pod ochranu autorského práva. Ale software může být často i součást
        průmyslově-právních řešení. Detailní informace ohledně patentování software lze najít například zde:
        <a href="https://www.epo.org/law-practice/legal-texts/html/guidelines/e/g_ii_3_6.htm">https://www.epo.org/law-practice/legal-texts/html/guidelines/e/g_ii_3_6.htm</a><br/>
        <br/>
        <br/>
    </BasePdf>
};
export default SecurityModulePdf;
